import { ReportsRepository,  } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    damages_info: [],
    work_blocks: [],
    materials_used: [],
    waste_generated: [],
  },
  mutations: {
    SET_VAR (state, params) {
      state[params.key] = params.value
    },
  },
  actions: {
    damagesInfo ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        obj.endpoint = 'damages_info'
        ReportsRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('SET_VAR', { key: 'damages_info', value: data })
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    workBlocks ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        obj.endpoint = 'work_blocks'
        ReportsRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('SET_VAR', { key: 'work_blocks', value: data })
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    materialsUsed ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        obj.endpoint = 'materials_used'
        ReportsRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('SET_VAR', { key: 'materials_used', value: data })
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    wasteGenerated ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        obj.endpoint = 'waste_generated'
        ReportsRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('SET_VAR', { key: 'waste_generated', value: data })
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
  }
}
